import { render, staticRenderFns } from "./CardSchedule.vue?vue&type=template&id=3e60095b"
import script from "./CardSchedule.vue?vue&type=script&lang=js"
export * from "./CardSchedule.vue?vue&type=script&lang=js"
import style0 from "./CardSchedule.vue?vue&type=style&index=0&id=3e60095b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QBtn});qInstall(component, 'directives', {ClosePopup});
